const buildSliderData = (data) => [
    {
        phrase: "Una bicicleta azul",
        leftImg_src: data.bicicletaAzul,
        leftImg_correct: true,
        rightImg_src: data.bicicletaAmarilla,
        rightImg_correct: false
    },
    {
        phrase: "Dos bicicletas azules",
        leftImg_src: data.dosBicicletasAzules,
        leftImg_correct: true,
        rightImg_src: data.dosBicicletasDiferentes,
        rightImg_correct: false
    },
    {
        phrase: "Dos bicicletas azules por un día por favor.",
        leftImg_src: data.verdesPorUnDia,
        leftImg_correct: false,
        rightImg_src: data.azulesPorUnDia,
        rightImg_correct: true
    }
];

export { buildSliderData };
